import { writable } from 'svelte/store'

export const statusInteraction = writable([
    {
        activeLayer:4,
        badge1:false,
        badge2:false,
        badge3:false,
        badge4:false,
        badge5:false,
        badge6:false,
        badge7:false,
        badge8:false,
        badge9:false,
        togle1:false,
        togle2:false,
        togle3:false,
        togle4:false,
        togle5:false,
        togle6:false,
        togle7:false,
        togle8:false,
        togle9:false,
        togle10:false,
        togle11:false,
        togle12:false,
        togle13:false,
        togle14:false,
        togle15:false,
        togle16:false,
        togle17:false,
        togle18:false,
        togle19:false,
        togle20:false,
        togle21:false,
        togle22:false,
        togle23:false,
        togle24:false,
        togle25:false,
        togle26:false,
        togle27:false,
        togle28:false,
        togle29:false,
        togle33:false,
        togle36:false,
        togle37:false
      }
])